/**
 * @generated SignedSource<<a875a154a7af3fe9513fbf819010cd2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeRuleSetCommunity_meter",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tradePointId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FlatPricingForm_meter"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeOfUsePricingForm_meter"
    }
  ],
  "type": "Meter",
  "abstractKey": null
};

node.hash = "98bf1c4b11024c87112a549bb114150f";

module.exports = node;
